import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.missionContainer = document.querySelector('.c-mission_container');
    }

    play(e){
        if (e.way == 'enter') {
            this.missionContainer.classList.add('-visible');
        } else {
            this.missionContainer.classList.remove('-visible');
        }
    }
}
